import { PaymentFailurePage } from "@/interface/pages/subscriptions/payment-failure-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/users/subscription/failure")({
  component: PaymentFailurePage,
});
